import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { TranslateService } from '@ngx-translate/core';
import { List } from 'immutable';
import { RsvpStore } from '../service/rsvp.store';
import { Rsvp } from '../models/rsvp';

@Injectable()
export class RsvpResolver implements Resolve<any> {
  constructor(private rsvpStore: RsvpStore,
              private translateService: TranslateService) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<List<Rsvp>> {
    const id = route.params[ 'id' ];
    const eventPartyId = route.params[ 'eventPartyId' ];

    if (!id) {
      throw new Error(this.translateService.instant('MESSAGES.ERROR.COULD_NOT_GET_RSVPS'));
    }

    if (eventPartyId) {
      return this.rsvpStore.loadRsvpsByParty(id, eventPartyId);
    } else {
      return this.rsvpStore.loadRsvps(id);
    }

  }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/rsvp/rsvp.resolver.ts